import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

const OrderSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking');
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    } else {
      setStatus('error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    let attempts = 0;
    const maxAttempts = 5;

    const poll = async () => {
      if (attempts >= maxAttempts) {
        setStatus('timeout');
        return;
      }

      try {
        const response = await api.get(`/checkout/status/${sessionId}`);
        
        if (response.data.payment_status === 'paid') {
          setStatus('success');
          setOrderId(response.data.order_id);
        } else if (response.data.payment_status === 'failed' || response.data.payment_status === 'expired') {
          setStatus('error');
        } else {
          attempts++;
          setTimeout(poll, 2000);
        }
      } catch (error) {
        setStatus('error');
      }
    };

    poll();
  };

  return (
    <div className="container mx-auto px-4 py-16 text-center">
      {status === 'checking' && (
        <div data-testid="payment-checking">
          <Loader2 className="h-16 w-16 mx-auto mb-4 animate-spin text-primary" />
          <h1 className="text-2xl font-heading font-bold mb-2">Zahlung wird überprüft...</h1>
          <p className="text-muted-foreground">Bitte warten Sie einen Moment</p>
        </div>
      )}

      {status === 'success' && (
        <div data-testid="payment-success">
          <CheckCircle className="h-16 w-16 mx-auto mb-4 text-green-500" />
          <h1 className="text-3xl font-heading font-bold mb-4 text-green-600">Zahlung erfolgreich!</h1>
          <p className="text-muted-foreground mb-8">
            Vielen Dank für Ihre Bestellung. Sie erhalten in Kürze eine Rechnung per E-Mail.
          </p>
          <div className="space-x-4">
            <Button onClick={() => navigate('/orders')} data-testid="view-orders-button">
              Meine Bestellungen
            </Button>
            <Button variant="outline" onClick={() => navigate('/')} data-testid="home-button">
              Zur Startseite
            </Button>
          </div>
        </div>
      )}

      {(status === 'error' || status === 'timeout') && (
        <div data-testid="payment-error">
          <XCircle className="h-16 w-16 mx-auto mb-4 text-red-500" />
          <h1 className="text-3xl font-heading font-bold mb-4 text-red-600">Zahlung fehlgeschlagen</h1>
          <p className="text-muted-foreground mb-8">
            Es gab ein Problem bei der Zahlungsabwicklung. Bitte versuchen Sie es erneut.
          </p>
          <div className="space-x-4">
            <Button onClick={() => navigate('/cart')} data-testid="back-to-cart-button">
              Zurück zum Warenkorb
            </Button>
            <Button variant="outline" onClick={() => navigate('/')} data-testid="home-button">
              Zur Startseite
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderSuccessPage;